<template>
  <div
    :class="[
      $style.container,
      {
        [$style.is24]: isIs24,
        [$style.hg]: !isIs24,
      },
    ]"
  >
    <div v-for="item in valueItems" :key="item.title" :class="$style.valueBoxWrapper">
      <img
        :src="item.getSvgIcon()"
        loading="lazy"
        :alt="$t(item.title)"
        :class="$style.illustrationImage"
      />

      <div :class="$style.contentWrapper">
        <h3 :class="$style.heading">{{ $t(item.title) }}</h3>
        <p :class="$style.description">
          {{ $t(item.description) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LandingValueFastHg from '@/assets/images/landing-value/landing-value-fast-hg.svg?url';
import LandingValueFastIs24 from '@/assets/images/landing-value/landing-value-fast-is24.svg?url';
import LandingValueFreeHg from '@/assets/images/landing-value/landing-value-free-hg.svg?url';
import LandingValueFreeIs24 from '@/assets/images/landing-value/landing-value-free-is24.svg?url';
import LandingValueProvenHg from '@/assets/images/landing-value/landing-value-proven-hg.svg?url';
import LandingValueProvenIs24 from '@/assets/images/landing-value/landing-value-proven-is24.svg?url';
import { isPlatformIs24 } from '@/helpers/Platform/Platform';

// Component data
const isIs24 = isPlatformIs24();

const valueItems = [
  {
    title: 'landing.value.free.title',
    description: 'landing.value.free.text',
    getSvgIcon: () => (isIs24 ? LandingValueFreeIs24 : LandingValueFreeHg),
  },
  {
    title: 'landing.value.fast.title',
    description: 'landing.value.fast.text',
    getSvgIcon: () => (isIs24 ? LandingValueFastIs24 : LandingValueFastHg),
  },
  {
    title: 'landing.value.proven.title',
    description: 'landing.value.proven.text',
    getSvgIcon: () => (isIs24 ? LandingValueProvenIs24 : LandingValueProvenHg),
  },
];
</script>

<style lang="scss" module>
@use '@/assets/variables' as *;

.container {
  display: flex;
  flex-direction: column;
  gap: $space-100;

  @include grid-media-query(sm) {
    flex-direction: row;
    gap: $space-250;
  }
}

.valueBoxWrapper {
  display: flex;
  flex: 1;
  gap: $space-100;
}

.contentWrapper {
  display: flex;
  flex-direction: column;
}

.illustrationImage {
  width: fit-content;
}

.heading {
  margin-top: 0;
  margin-bottom: $space-50;

  @include heading-3;
}

.description {
  margin-top: 0;
  margin-bottom: 0;

  @include body-2;
}

.container.hg {
  .valueBoxWrapper {
    padding: $space-100;
    background-color: $color-grey-30;
    border-radius: $border-radius-l;

    @include grid-media-query(sm) {
      flex-direction: column;
    }

    @include grid-media-query(md) {
      flex-direction: row;
    }
  }

  .illustrationImage {
    align-self: baseline;
    width: 48px;
    height: 48px;
  }
}

.container.is24 {
  .contentWrapper {
    align-items: center;
  }

  .valueBoxWrapper {
    flex-direction: column;
  }

  .illustrationImage {
    align-self: center;
    width: 64px;
    height: 64px;
  }

  .description {
    text-align: center;
  }
}
</style>
